import { action, get, post, put } from 'lib/actionHelpers.js';
import pluck from '../../lib/pluck.js';

export const getServiceProvider = (id, callback) =>
  get(`/provider/${id}`, {
    action: 'GET_SERVICE_PROVIDER',
    callback,
    alwaysAllowRequest: true,
  });

export const getServiceProviderEmails = ({ serviceProviderId, callback }) =>
  get(`/provider/${serviceProviderId}/emails`, {
    action: 'GET_SERVICE_PROVIDER_EMAILS',
    callback,
  });

export const getServiceProvidersSummary = (data = {}, callback) =>
  get('/service-provider/providers/summary', {
    crossDomain: true,
    action: 'GET_SERVICE_PROVIDERS',
    alwaysAllowRequest: true,
    callback,
  });

export const postServiceProvider = (data = {}, callback) =>
  post('/service-provider', {
    data,
    action: 'POST_SERVICE_PROVIDER',
    callback,
  });

export const updateServiceProviderMessagesCount = () => () => {
  action('UPDATE_SERVICE_PROVIDER_MESSAGE_COUNT');
};

export const getGlobalLeadLoopSummary = ({ days, callback }) =>
  get('/reporting/global/summary', {
    query: {
      days,
    },
    action: 'GET_GLOBAL_LEADLOOP_SUMMARY',
    callback,
  });

export const putServiceProvider = (data = {}, callback) =>
  put('/service-provider', {
    data: pluck(data, ['active', 'providerName', 'additionalFields', 'serviceProviderId', 'defaultTrackedPhoneId'], 'snake'),
    action: 'PUT_SERVICE_PROVIDER',
    callback,
  });
